module.exports = __webpack_public_path__ + "img/exclamation-octagon-fill.e06ebbde.svg";